import { render, staticRenderFns } from "./CheckInRecord.vue?vue&type=template&id=0ba22181"
import script from "./CheckInRecord.vue?vue&type=script&lang=js"
export * from "./CheckInRecord.vue?vue&type=script&lang=js"
import style0 from "./CheckInRecord.vue?vue&type=style&index=0&id=0ba22181&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports